export default {
  namespaced: true,
  state: () => ({
    list: [],
    archive: [],
  }),
  mutations: {
    addNotification(state, notification) {
      state.list.push(notification);
    },
    removeNotification(state) {
      const notification = state.list.slice(0, 1);
      if (state.archive.length > 500) {
        state.archive = state.archive.slice(450);
      }
      state.archive.push(notification);
      state.list.splice(0, 1);
    },
    removeById(state, id) {
      const idx = state.list.findIndex((n) => n.id === id);
      if (idx === -1) return;
      if (state.archive.length > 500) {
        state.archive = state.archive.slice(450);
      }
      state.archive.push(state.list[idx]);
      state.list.splice(idx, 1);
    },
  },
  actions: {
    new(
      { commit },
      {
        title = 'Notification Headline',
        message = '',
        icon = null,
        type = undefined,
      }
    ) {
      console.log('--> [ Notification ] ', title, message);
      if (process.env.NOTIFICATIONS) {
        commit('addNotification', {
          title,
          message,
          icon,
          type,
          id: Math.floor(Math.random() * Date.now()),
        });
        setTimeout(() => {
          console.log('notification remove');
          commit('removeNotification');
        }, 6000);
      }
    },
    // Remote-getriggerte Overlay-Nachricht (Admin / ControlApp). Bewusst NICHT
    // durch process.env.NOTIFICATIONS gegated — sie muss immer erscheinen.
    // Typen: 'alarm' | 'info'. Ohne confirm verschwindet sie nach `timeout`
    // Sekunden (Default 8); mit confirm bleibt sie bis der Gast mit OK bestätigt.
    overlay({ commit }, { title = '', message = '', type = 'info', timeout, confirm = false }) {
      const id = Math.floor(Math.random() * Date.now());
      commit('addNotification', {
        id,
        title,
        message,
        type: type || 'info',
        confirm: !!confirm,
      });
      if (!confirm) {
        const secs = Number(timeout) > 0 ? Number(timeout) : 8;
        setTimeout(() => {
          commit('removeById', id);
        }, secs * 1000);
      }
    },
    dismiss({ commit }, id) {
      commit('removeById', id);
    },
    socket({ dispatch }, { title, message }) {
      dispatch('new', { title, message, type: 'socket' });
    },
    error({ dispatch }, { title, message }) {
      const errorObject = {
        title: 'Error: ' + title,
        message,
        type: 'error',
      };
      dispatch('new', errorObject);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/notification.js